import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormControl,FormGroup,FormBuilder,FormArray,ValidatorFn} from "@angular/forms";
import { DashboardService} from "../../services/dashboard/dashboard.service";
import {CommonService} from "../../services/common/common.service"
import { PdfViewerDialog } from "../pdfviewer/pdf-export-dialog.component";
@Component({
    selector: 'export-dashboard-viewer',
    templateUrl: 'dashboard-export-dialog.component.html',
    styleUrls: ["dashboard-export-dialog.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ExportDashboardViewerDialog implements OnInit {
    widgetListGroup:any;
    groupListForm: FormGroup;
    checkBoxGroupList:any =[];
    dashboardId:string = "";
    isPreviousCompleted = false;
    dashboardName:string = "";
    userExportPer:any;
    exportOption=["excel","csv","pdf"];
    headersContant =[
      { id:"widgetId",value:"Widget Id" },
      { id:"widgetName",value:"Widget Name" },
      { id:"kpiGroup",value:"KPI Group" },
      { id:"kpi",value:"KPI" },
      { id:"date",value:"Date" },
      { id:"dateFrom",value:"DateFrom" },
      { id:"value",value:"Value" }
     ];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb:FormBuilder,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ExportDashboardViewerDialog>,
    private dashboardService: DashboardService,
    private commonService: CommonService
  ) {
    this.widgetListGroup = data.groupListGroup;
    this.dashboardId = data.dashboardId;
    this.dashboardName = data.dashboardName;
    this.userExportPer = data.userExportPer;
    this.widgetListGroup.forEach(element => {
        this.checkBoxGroupList.push({id : element._id,groupName:element.groupName});
    });
    this.createGroupList();
  }

  ngOnInit() {
    
  }

  createGroupList(){
    let showSelectedFileType = this.userExportPer["excel"] === "0" ? "excel" : this.userExportPer["pdf"] === "0" ? "pdf" : "csv";

    const headersControls = this.headersContant.map(c => new FormControl(true));

    const controls = this.checkBoxGroupList.map(c => new FormControl(true));
    this.groupListForm = this.fb.group({
        groupIdsList: this.fb.array(controls,minSelectedCheckboxes(1)),
        exportType:[showSelectedFileType],
        headersList:this.fb.array(headersControls,minSelectedCheckboxes(1))
    });
    // const groupControls = this.groupListForm.get("groupIdsList") as FormArray;
    // this.checkBoxGroupList.forEach(c => groupControls.push(new FormControl(true)));
  }

  getGroupIds(){
    return <FormArray>this.groupListForm.controls['groupIdsList'];
  }

  onSubmit(){
    let selectedGroupIds = this.groupListForm.value.groupIdsList
    .map((v, i) => v ? this.checkBoxGroupList[i].id : null)
    .filter(v => v !== null);
    let groupId = "";
    selectedGroupIds.forEach( (o)=> groupId += o +",");
    this.exportDocument(this.groupListForm.get('exportType').value,groupId)  

  }

  exportDocument(exportType,groupIds){
      this.isPreviousCompleted = true;
    //environment.baseUrl +
    
    let url =  "export/dashboard/" + this.dashboardId +"/" + exportType + "?groups=" + groupIds  +"&widgets=";
    if(exportType == "pdf"){
      this.dialog.open(PdfViewerDialog, {
        data:{ url:url ,exportType:exportType,dashboardName:this.dashboardName },
        height: "auto",
        width: "1000px",
        panelClass: "export-modal"
      });
      this.dialogRef.close();
    }

    else{
    url = this.HeadersVal(url);
    this.dashboardService.downloadReport(url).subscribe( (res) => {
        var blob = new Blob([res], {type: res.type});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileExt = exportType === "excel" ? ".xlsx" : ".csv"; 
        var fileName = this.dashboardName + fileExt;
        link.download = fileName;
        link.click();
        this.isPreviousCompleted = false;
    }
    ,(err)=>{
      this.commonService.openSnackBar("Failed while generating " + exportType + " report", "");
      this.isPreviousCompleted = false;
    });
  }
}

  HeadersVal(url):string{
  let selectedHeaders = this.groupListForm.value.headersList
  .map((v, i) => v ? this.headersContant[i].id : null)
  .filter(v => v !== null);
  url += "&selectedh=" + selectedHeaders;
  return url;
}

}
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/dashboardexport/dashboard-export-dialog.component.ts